<template>
  <ToolAccessState
    title="Carteras no incluidas"
    message="El acceso básico a la web no incluye la funcionalidad de carteras. Para acceder, completa el curso avanzado y contrata un plan."
    action-label="Contratar plan"
    :show-secondary-action="true"
    secondary-action-label="Curso avanzado"
    secondary-action-href="https://online.eurekers.com/curso-avanzado-eurekers/"
    secondary-action-target="_blank"
  />
</template>

<script>
import ToolAccessState from "@/shared/components/common/ToolAccessState.vue";

export default {
  name: 'PortfolioAccessDenied',
  components: {
    ToolAccessState
  },
};
</script>
